export default __webpack_public_path__ + "static/media/cvv-card.3370bc63.svg";